// Hire inbox unread badge (UI8-16): one count fetch per page load,
// shown in the profile dropdown and as a dot on the header avatar
angular.module("UI8.controllers").controller("InboxBadgeController", [
  "$http",
  "$scope",
  function ($http, $scope) {
    $scope.inboxUnread = 0;

    if (window.UI8 && UI8.loggedIn && UI8.shotsVisible) {
      $http.get("/api/hire/unread").then(function (res) {
        $scope.inboxUnread = (res.data && res.data.count) || 0;
      });
    }
  },
]);
